import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import FooterCTA from './components/Footer/FooterCTA';
import HomePage from './pages/HomePage';
import CourseDetail from './pages/CourseDetail';
import SkillDetail from './pages/SkillDetail';
import TeamsPage from './pages/TeamsPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import TeacherDashboard from './pages/TeacherDashboard';
import ChronosGeoPage from './pages/ChronosGeoPage';
import FounderWorkspace from './pages/FounderWorkspace'; // NUEVO
import AccountsWorkspace from './pages/AccountsWorkspace'; // NUEVO
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            
            {/* Rutas de Cursos */}
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/skills/:id" element={<SkillDetail />} />
            
            {/* Páginas Estáticas */}
            <Route path="/equipos" element={<TeamsPage />} />
            <Route path="/historias" element={<SuccessStoriesPage />} />
            <Route path="/chronos-geo" element={<ChronosGeoPage />} />
            
            {/* Rutas Protegidas (ERP Interno) */}
            <Route path="/admin-studio-x99-bullminer" element={<TeacherDashboard />} />
            <Route path="/cuentas" element={<AccountsWorkspace />} />
            
            {/* Ruta Dinámica para Fundadores (Debe ir al final) */}
            <Route path="/:founderName" element={<FounderWorkspace />} />
            
          </Routes>
        </main>
        <FooterCTA />
      </div>
    </Router>
  );
}

export default App;